<template>
  <Modal v-model="distributorPaymentModal" :title="$t('key1000609')" :transfer="false" :mask-closable="false"
    width="600" @on-visible-change="distributorPaymentChange">
    <p class="mb15" v-if="distributorPaymentType === 'all'">{{ $t('key1000610') }}<span class="themeColor">{{ selectTableData.length }}</span>{{ $t('key1000611') }}</p>
    <div class="flex align-items-center mb24">
      <span>{{ $t('key1000612') }}</span>
      <RadioGroup v-model="payType">
        <Radio :label="1">{{ $t('key1000613') }}</Radio>
        <Radio :label="2" v-if="offlinePayment">{{ $t('key1000614') }}</Radio>
      </RadioGroup>
    </div>
    <p>
      {{ $t('key1000615') }}<br/>
      {{ payTypeText }}
    </p>
    <template #footer>
      <Button @click="distributorPaymentModal = false">{{ $t('key1000112') }}</Button>
      <Button type="primary" @click="distributorPaymentBtn">{{ $t('key1000111') }}</Button>
    </template>
  </Modal>
</template>

<script>
import aliasb03645cf6abd4d56a73b13687765a5d8 from '@/locale/i18nUtils.js';

import Mixin from '@/components/mixin/common_mixin';
import api from '@/api/';
import {commonLocalStorage, insufficientAccountBalance} from "@/utils/common";

export default {
  name: 'distributorPaymentModal',
  mixins: [Mixin],
  props: {
    orderSource: {
      type: String,
      default: null
    }
  },
  data() {
    let v = this;
    return {
      distributorPaymentModal: false,
      payType: 1,
      distributorPaymentType: null,
      selectTableData: [],
    }
  },
  computed: {
    payTypeText() {
      return this.payType === 1 ? aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000606') :
        aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000607');
    },
    // 获取当前登录用户的信息
    userInfo() {
      if (this.$store.state.erpConfig) {
        return this.$store.state.erpConfig.userInfo;
      } else {
        return '';
      }
    },
    offlinePayment() {
      const obj = commonLocalStorage.getItem('configurationItemInfo') ?? this.$store.state.configurationItemInfo;
      return Number(obj?.offlinePayment) === 1;
    }
  },
  methods: {
    // 初始化数据
    initDistributorPaymentData(type, data) {
      this.distributorPaymentType = type;
      this.selectTableData = data;
      this.distributorPaymentModal = true;
    },
    // 确定按钮
    distributorPaymentBtn() {
      let query;
      let url;
      switch (this.orderSource) {
        // YMS订单
        case 'myOrder':
          query = {
            packageCodes: this.selectTableData.map((item) => item.packageCode),
            payType: this.payType
          }
          url = api.post_ymsDistributorPackageInfo_payToCreateOrder;
          break;
        // 备货单
        case 'distributorStockList':
          query = {
            ymsStockUpInfoId: this.selectTableData[0].ymsStockUpInfoId,
            payType: this.payType
          }
          url = api.post_ymsDistributorStockUpInfo_confirmPayment;
          break;
      }
      // 校验余额
      const totalPrice = this.selectTableData.reduce((sum, item) => {
        return sum + (item.totalPrice || 0);
      }, 0);

      let obj = {
        distributorMerchantId: this.userInfo.merchantId,
        totalPrice: totalPrice
      }
      const handlePayment = () => {
        this.axios.post(url, query, {loading: true, loadingText: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000247')}).then(response => {
          let code = response.data.code;
          this.distributorPaymentModal = false;
          if (code === 0) {
            let text = this.payType === 1 ? aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000608') : aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000155');
            this.$Message.success(text);
            this.selectTableData = [];
            this.$emit('updateData', true);
          } else if (code === 111195) {
            /* insufficientAccountBalance(this);*/
          }
        });
      }
      switch (this.payType) {
        case 1:
          this.orderVerificationOfUserBalance(obj).then((value) => {
            if (value) {
              handlePayment();
            }
          });
          break;
        case 2:
          handlePayment();
          break;
      }

    },
    // 监听弹窗
    distributorPaymentChange(value) {
      if (!value) {
        this.payType = 1;
        this.selectTableData = [];
      }
    }
  }
};
</script>

<style lang="less">

</style>
